import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import {
  EntidadDTO,
  EntidadInteroperabilidadDTO, EnvioFormularioManualDTO,
} from '../modules/tramites/models/entidadDTO';
import { Observable } from 'rxjs';
import { TramiteDTO } from '../modules/tramites/models/tramiteDTO';
import { map } from 'rxjs/operators';
import { of } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class TramiteService {
  private apiUrl = environment.apiUrl;
  private baseUrl = '/integrador';
  private apiSSM = 'ssm/expediente/detalle';

  constructor(private http: HttpClient) {}

  listaEntidadesYTramites(activos: boolean = true): Observable<EntidadDTO[]> {
    return this.http
      .get<EntidadDTO[]>(`${this.apiUrl}/lista/tipotramite/entidades`, {
        params: {
          activos: activos,
        },
      })
      .pipe(
        map((entidades: EntidadDTO[]) =>
          entidades.sort((a: EntidadDTO, b: EntidadDTO) =>
            a.Entidad.localeCompare(b.Entidad)
          )
        )
      );
  }

  listaEntidades(): Observable<EntidadInteroperabilidadDTO[]> {
    return this.http.get<EntidadInteroperabilidadDTO[]>(
      `${this.apiUrl}${this.baseUrl}/obtenerEntidades`
    );
  }

  listaEntidadesPublica(): Observable<EntidadInteroperabilidadDTO[]> {
    return this.http.get<EntidadInteroperabilidadDTO[]>(
      `${this.apiUrl}/lista/integrador/obtenerEntidadesPublica`
    );
  }

  obtenerNombreCompletoTramite(nombreCorto: string): Observable<{ nombreCompleto: string }> {
    return this.http.get<{ nombreCompleto: string }>(
      `${this.apiUrl}/tramite/tipo-tramite/${nombreCorto}/nombre-completo`
    );
  }

  fechaUltimoCorteInteroperabilidadPorProceso(): Observable<EnvioFormularioManualDTO[]> {
    return this.http.get<EnvioFormularioManualDTO[]>(
      `${this.apiUrl}${this.baseUrl}/fechaUltimoCorteInteroperabilidadPorProceso`
    );
  }

  editarServicioDisponible(
    entidadId: number,
    nombreEntidad: string,
    disponible: boolean
  ): Observable<void> {
    const url = `${this.apiUrl}${this.baseUrl}/editarServicioDisponible/${entidadId}`;
    const body = {
      nombreEntidad,
      disponible,
    };
    return this.http.patch<void>(url, body);
  }

  consultarTramitePendiente(idUsuario: number, idTramite: number | string) {
    return this.http.get<{ Id: number }>(
      `${this.apiUrl}/tramite/tramite-pendiente/${idUsuario}/${idTramite}`
    );
  }

  cargarTramitePendiente(idTramite: number): Observable<TramiteDTO> {
    return this.http.get<TramiteDTO>(
      `${this.apiUrl}/tramite/tramite-pendiente/cargar/${idTramite}`
    );
  }

  actualizarEstadoTramite(id: number, estado: boolean): Observable<any> {
    return this.http.patch(`${this.apiUrl}/tramite/${id}/estado`, {
      Estado: estado,
    });
  }

  envioAEntidad(
    idTramite: number,
    nombreCortoTramite: string | undefined = undefined,
    idioma?: string
  ): Observable<any> {
    let url = `${this.apiUrl}/tramite/envio-a-entidad/${idTramite}`;

    if (nombreCortoTramite) {
      url += `/${nombreCortoTramite}`;
    }

    const params: any = {};
    if (idioma) {
      params.idioma = idioma;
    }

    return this.http.get<any>(url, { params });
  }
  obtenerNombreEntidadPorId(idEntidad: number): Observable<{ entidad: string; nombreCompletoTramite: string | null }> {
     return this.http.get<{ entidad: string; nombreCompletoTramite: string | null }>(`${this.apiUrl}/tramite/entidad/${idEntidad}`);
   }
   obtenerNombreEntidadPorIdNombreCorto(idEntidad: number,nombreCortoTramite:string): Observable<{ entidad: string; nombreCompletoTramite: string | null }> {
        return this.http.get<{ entidad: string; nombreCompletoTramite: string | null }>(`${this.apiUrl}/tramite/entidad/${idEntidad}/${nombreCortoTramite}`);
      }

  verificarCorreo(
    tramiteId: string,
    correo?: string,
    token?: string
  ): Observable<{ success: boolean; tramiteId?: string }> {
    let params: any = {};

    // Agregar parámetros según lo que venga
    if (token) {
      params.token = token;
    }
    if (correo) {
      params.correo = correo;
    }

    return this.http.get<{ success: boolean; tramiteId?: string }>(
      `${this.apiUrl}/tramite/${tramiteId}/verificar-correo`,
      { params }
    );
  }

  generarTokenVisualizacion(tramiteId: string, correo: string): Observable<{ token: string; url: string }> {
    return this.http.post<{ token: string; url: string }>(
      `${this.apiUrl}/tramite/${tramiteId}/generar-token-visualizacion`,
      { correo }
    );
  }


}
